import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrintJob } from './print-job';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrintJobService {

  printersApi = environment.apiPath + '/printers';
  separator = '/';

  constructor(private http: HttpClient) { }

  /**
   * /{name}/jobs/{state}
   */
  getPrintJobs(printerName: string, printJobQueueState: string): Observable<PrintJob[]> {
    console.log('querying API for Printername: ' + printerName + ' with printJobQueueState: ' + printJobQueueState);
    return this.http.get<PrintJob[]>(this.printersApi + this.separator + printerName + '/jobs/' + printJobQueueState);
  }

  moveJob(sourcePrinter: string, targetPrinter: string, jobId: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + sourcePrinter + '/jobs/' + jobId + '/move/' + targetPrinter, null);
  }

  holdJob(printerName: string, jobId: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/jobs/' + jobId + '/hold', null);
  }

  releaseJob(printerName: string, jobId: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/jobs/' + jobId + '/release', null);
  }

  cancelJob(printerName: string, jobId: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/jobs/' + jobId + '/cancel', null);
  }
}
